<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <div class="d-flex mb-4">
        <h2>{{ $t("reports.semenEmbryoProductionReport") }}</h2>
      </div>

      <!-- filters -->
      <!-- <v-row no-gutters>
        <v-col cols="12" sm="3" md="2">
          <v-select
            :items="countries"
            item-text="name"
            item-value="id"
            dense
            outlined
            class="shrink mr-2"
            v-model="countary"
            :placeholder="$t('reports.filterByCountry')"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <v-select
            :items="regions"
            item-text="name"
            item-value="roleNumber"
            dense
            outlined
            class="shrink mr-2"
            v-model="region"
            :placeholder="$t('reports.filterByRegion')"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <v-select
            :items="regions"
            item-text="name"
            item-value="roleNumber"
            dense
            outlined
            class="shrink mr-2"
            v-model="region"
            :placeholder="$t('reports.filterByFarm')"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <v-select
            :items="regions"
            item-text="name"
            item-value="roleNumber"
            dense
            outlined
            class="shrink mr-2"
            v-model="region"
            :placeholder="$t('reports.filterByMonth')"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <v-select
            :items="regions"
            item-text="name"
            item-value="roleNumber"
            dense
            outlined
            class="shrink mr-2"
            v-model="region"
            :placeholder="$t('reports.filterByDate')"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <v-select
            :items="regions"
            item-text="name"
            item-value="roleNumber"
            dense
            outlined
            class="shrink"
            v-model="region"
            :placeholder="$t('reports.filterByRole')"
          ></v-select>
        </v-col>
      </v-row> -->

      <!-- chips -->
      <v-row no-gutters>
        <v-col cols="12" sm="3" md="3">
          <v-card class="mx-auto border rounded-lg" height="120" outlined>
            <v-list-item class="text-end">
              <v-list-item-content class="mr-n4">
                <v-list-item-title class="mt-n3">
                  <v-avatar size="15" color="#DAE1EC"></v-avatar>
                  <v-menu>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn dark icon v-bind="attrs" v-on="on">
                        <v-icon color="#DAE1EC">mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </template>
                  </v-menu>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item three-line class="mt-n11">
              <v-list-item-avatar
                size="70"
                color="#DAE1EC"
              ></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-h5 subtitle-2 font-weight-black">
                  {{ counts.semen }}
                </v-list-item-title>
                <v-list-item-subtitle class="mt-n3 font-weight-medium">
                  {{ $t("reports.semenProducts") }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-card class="mx-auto border rounded-lg ml-5" height="120" outlined>
            <v-list-item class="text-end">
              <v-list-item-content class="mr-n4">
                <v-list-item-title class="mt-n3">
                  <v-avatar size="15" color="#DAE1EC"></v-avatar>
                  <v-menu>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn dark icon v-bind="attrs" v-on="on">
                        <v-icon color="#DAE1EC">mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </template>
                  </v-menu>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item three-line class="mt-n11">
              <v-list-item-avatar
                size="70"
                color="#DAE1EC"
              ></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-h5 subtitle-2 font-weight-black">
                  {{ counts.diary }}
                </v-list-item-title>
                <v-list-item-subtitle class="mt-n3 font-weight-medium">
                  {{ $t("reports.dairyProducts") }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-card class="mx-auto border rounded-lg ml-5" height="120" outlined>
            <v-list-item class="text-end">
              <v-list-item-content class="mr-n4">
                <v-list-item-title class="mt-n3">
                  <v-avatar size="15" color="#DAE1EC"></v-avatar>
                  <v-menu>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn dark icon v-bind="attrs" v-on="on">
                        <v-icon color="#DAE1EC">mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </template>
                  </v-menu>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item three-line class="mt-n11">
              <v-list-item-avatar
                size="70"
                color="#DAE1EC"
              ></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-h5 subtitle-2 font-weight-black">
                  {{ counts.meat }}
                </v-list-item-title>
                <v-list-item-subtitle class="mt-n3 font-weight-medium">
                  {{ $t("reports.meatProducts") }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-card class="mx-auto border rounded-lg ml-5" height="120" outlined>
            <v-list-item class="text-end">
              <v-list-item-content class="mr-n4">
                <v-list-item-title class="mt-n3">
                  <v-avatar size="15" color="#DAE1EC"></v-avatar>
                  <v-menu>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn dark icon v-bind="attrs" v-on="on">
                        <v-icon color="#DAE1EC">mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </template>
                  </v-menu>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item three-line class="mt-n11">
              <v-list-item-avatar
                size="70"
                color="#DAE1EC"
              ></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-h5 subtitle-2 font-weight-black">
                  {{ counts.totalProducts }}
                </v-list-item-title>
                <v-list-item-subtitle class="mt-n3 font-weight-medium">
                  {{ $t("reports.totalProducts") }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>

      <!-- search -->
      <v-row no-gutters class="mt-10">
        <v-col cols="12" sm="4" md="4">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            outlined
            :placeholder="$t('search')"
            dense
            v-model="search"
            @input="resetSearchOnEmpty"
            class="shrink"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3" class="ml-n4">
          <v-btn
            :disabled="search.length < 1"
            color="primary"
            height="40"
            width="40"
            max-width="40"
            outlined
            class="ml-8"
            @click="searchItems"
          >
            <v-icon>mdi-filter-outline</v-icon>
          </v-btn>
        </v-col>

        <v-spacer></v-spacer>

        <v-col cols="12" sm="3" md="3">
          <v-select
            :items="countries"
            item-text="name"
            item-value="id"
            dense
            outlined
            class="shrink"
            v-model="countary"
            :placeholder="$t('animal.conceptionInfo.semenEmbryo')"
          ></v-select>
        </v-col>
      </v-row>

      <!-- tables -->
      <v-row>
        <v-col cols="12" md="6">
          <v-card
            class="mx-auto border rounded-lg mx-9 mt-5"
            elevation="0"
            outlined
          >
            <template>
              <div class="d-flex my-5">
                <p class="mt-2 ml-4">{{ $t('animal.conceptionInfo.semen') }}</p>
                <v-spacer></v-spacer>
                <div class="py-1 title">
                  {{ fromSemen }} - {{ toSemen }} of {{ totalSemen }}
                </div>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptionsSemen.page <= 1"
                  @click="pageChangeSemen(false)"
                >
                  <v-icon dark> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptionsSemen.page >= totalPagesSemen"
                  @click="pageChangeSemen(true)"
                >
                  <v-icon dark> mdi-chevron-right </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  @click="exportSemen"
                >
                  <v-icon dark> mdi-export </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  @click="
                    printPDF(
                      $refs.semen,
                      'Semen(Semen/Embryo Production Report)'
                    )
                  "
                >
                  <v-icon dark> mdi-printer </v-icon>
                </v-btn>
              </div>
            </template>
            <div ref="semen">
              <v-data-table
                :headers="headersForSemen"
                :items="itemsForSemen"
                :items-per-page="5"
                hide-default-footer
                :options.sync="tableOptionsSemen"
                :loading="loadingSemen"
                loading-text="Loading Semen Data..."
                :server-items-length="totalSemen"
              >
              </v-data-table>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card
            class="mx-auto border rounded-lg mx-9 mt-5"
            elevation="0"
            outlined
          >
            <template>
              <div class="d-flex my-5">
                <p class="mt-2 ml-4">{{ $t("reportings.embryo") }}</p>
                <v-spacer></v-spacer>
                <div class="py-1 title">
                  {{ fromEmbryo }} - {{ toEmbryo }} of
                  {{ totalEmbryo }}
                </div>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptionsEmbryo.page <= 1"
                  @click="pageChangeEmbryo(false)"
                >
                  <v-icon dark> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptionsEmbryo.page >= totalPagesEmbryo"
                  @click="pageChangeEmbryo(true)"
                >
                  <v-icon dark> mdi-chevron-right </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  @click="exportEmbryo"
                >
                  <v-icon dark> mdi-export </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  @click="
                    printPDF(
                      $refs.embryo,
                      'Embryo(Semen/Embryo Production Report)'
                    )
                  "
                >
                  <v-icon dark> mdi-printer </v-icon>
                </v-btn>
              </div>
            </template>
            <div ref="embryo">
              <v-data-table
                :headers="headersForEmbryo"
                :items="itemsForEmbryo"
                :items-per-page="5"
                hide-default-footer
                :options.sync="tableOptionsEmbryo"
                :loading="loadingEmbryo"
                loading-text="Loading Embryo Data..."
                :server-items-length="totalEmbryo"
              >
                <!-- <template v-slot:[`item.EmbryoMethod`]="{ item }">
                {{ item.EmbryoMethod.name }}
              </template> -->
              </v-data-table>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import ReportService from "@/_services/ReportingService.js";
import loadingMixin from "@/mixins/LoadingMixin";
import html2pdf from "html2pdf.js";
import printJS from "print-js";

export default {
  mounted() {
    document.title = this.$t('reports.analyticsAndReporting');
    this.getCountsFarmProducts();
    this.startLoading();
  },
  watch: {
    tableOptionsSemen: {
      handler() {
        this.getAllAnimalSemenData();
      },
      deep: true,
    },
    tableOptionsEmbryo: {
      handler() {
        this.getAllAnimalEmbryoData();
      },
      deep: true,
    },
  },
  data() {
    return {
      search: "",

      countries: [],
      regions: [],
      countary: null,
      region: null,
      breadcrumbs: [
        {
          text: this.$t('dashboard'),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t('reports.analyticsAndReporting'),
          disabled: true,
        },
        {
          text: this.$t('reports.semenEmbryoReport'),
          disabled: true,
        },
      ],

      headersForSemen: [
        { text: this.$t('dashboardS.sireId'), value: "sireId" },
        { text: this.$t('reports.numOfStraws'), value: "numOfStraws" },
        { text: this.$t('reports.collectionDate'), value: "collectionDate" },
      ],
      itemsForSemen: [
        {
          sireId: "89678",
          strawsNO: "05",
          collectionDate: "01/05/2020",
        },
        {
          sireId: "89679",
          strawsNO: "05",
          collectionDate: "01/05/2020",
        },
        {
          sireId: "89680",
          strawsNO: "04",
          collectionDate: "01/05/2020",
        },
        {
          sireId: "89681",
          strawsNO: "03",
          collectionDate: "01/05/2020",
        },
        {
          sireId: "89682",
          strawsNO: "04",
          collectionDate: "01/05/2020",
        },
        {
          sireId: "89683",
          strawsNO: "05",
          collectionDate: "01/05/2020",
        },
      ],

      headersForEmbryo: [
        { text: this.$t('dashboardS.damID'), value: "damId" },
        { text: this.$t('reports.numOfStraws'), value: "numOfStraws" },
        { text: this.$t('reports.collectionDate'), value: "collectionDate" },
      ],
      itemsForEmbryo: [
        {
          damId: "89678",
          strawsNO: "05",
          collectionDate: "01/05/2020",
        },
        {
          damId: "89679",
          strawsNO: "05",
          collectionDate: "01/05/2020",
        },
        {
          damId: "89680",
          strawsNO: "04",
          collectionDate: "01/05/2020",
        },
        {
          damId: "89681",
          strawsNO: "03",
          collectionDate: "01/05/2020",
        },
        {
          damId: "89682",
          strawsNO: "04",
          collectionDate: "01/05/2020",
        },
        {
          damId: "89683",
          strawsNO: "05",
          collectionDate: "01/05/2020",
        },
      ],

      tableOptionsSemen: {},
      fromSemen: 0,
      toSemen: 0,
      totalSemen: 1,
      totalPagesSemen: 1,

      tableOptionsEmbryo: {},
      fromEmbryo: 0,
      toEmbryo: 0,
      totalEmbryo: 1,
      totalPagesEmbryo: 1,

      farm: "FRM000012397505",
      categories: 83,
      productOptions: {
        page: 1,
        limit: 10,
      },

      counts: {},
      totalProduct: 10,

      loadingSemen: false,
      loadingEmbryo: false,
    }
  },
  methods: {
    async printPDF(reference, title) {
      let opt = {
        margin: 1,
        filename: `${title}.pdf`,
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: { scale: 1, useCORS: true },
        jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
      };

      let worker = await html2pdf()
        .set(opt)
        .from(reference)
        .toCanvas()
        .outputPdf("blob", `${title}.pdf`);
      let file = new File([worker], `${title}.pdf`, {
        type: "application/pdf",
      });
      var pdfUrl = await URL.createObjectURL(file);
      await printJS({ printable: `${pdfUrl}`, type: "pdf", showModal: true });
    },
    getAllAnimalSemenData() {
      this.loadingSemen = true;
      ReportService.getAllAnimalSemenData(this.tableOptionsSemen)
        .then((res) => {
          this.itemsForSemen = res.data.semenData.rows;
          // this.itemsForEmbryo = res.data.animalConception.rows;
          this.totalSemen = res.data.semenData.total_rows;
          this.totalPagesSemen = Math.ceil(
            this.totalSemen / this.tableOptionsSemen.itemsPerPage
          );
          this.fromSemen =
            (this.tableOptionsSemen.page - 1) *
              this.tableOptionsSemen.itemsPerPage +
            1;
          this.toSemen =
            this.tableOptionsSemen.page * this.tableOptionsSemen.itemsPerPage -
            (this.tableOptionsSemen.itemsPerPage - res.data.semenData.num_rows);
          this.loadingSemen = false;
        })
        .catch((err) => {
          this.stopLoading();
          console.log(err);
          this.loadingSemen = false;
        });
    },

    pageChangeSemen(t) {
      if (t) this.tableOptionsSemen.page = this.tableOptionsSemen.page + 1;
      else this.tableOptionsSemen.page = this.tableOptionsSemen.page - 1;

      this.getAllAnimalSemenData();
    },

    getAllAnimalEmbryoData() {
      this.loadingEmbryo = true;
      ReportService.getAllAnimalEmbryoData(this.tableOptionsEmbryo)
        .then((res) => {
          this.itemsForEmbryo = res.data.embryoData.rows;
          // this.itemsForEmbryo = res.data.animalConception.rows;
          this.totalEmbryo = res.data.embryoData.total_rows;
          this.totalPagesEmbryo = Math.ceil(
            this.totalEmbryo / this.tableOptionsEmbryo.itemsPerPage
          );
          this.fromEmbryo =
            (this.tableOptionsEmbryo.page - 1) *
              this.tableOptionsEmbryo.itemsPerPage +
            1;
          this.toEmbryo =
            this.tableOptionsEmbryo.page *
              this.tableOptionsEmbryo.itemsPerPage -
            (this.tableOptionsEmbryo.itemsPerPage -
              res.data.embryoData.num_rows);
          this.loadingEmbryo = false;
        })
        .catch((err) => {
          console.log(err);
          this.loadingEmbryo = false;
        });
    },
    exportSemen() {
      html2pdf(this.$refs.semen, {
        margin: 1,
        filename: "Semen Report.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },
    exportEmbryo() {
      html2pdf(this.$refs.embryo, {
        margin: 1,
        filename: "Embryo Report.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },
    pageChangeEmbryo(t) {
      if (t) this.tableOptionsEmbryo.page = this.tableOptionsEmbryo.page + 1;
      else this.tableOptionsEmbryo.page = this.tableOptionsEmbryo.page - 1;

      this.getAllAnimalEmbryoData();
    },

    getCountsFarmProducts() {
      ReportService.getCountsFarmProducts().then(async (res) => {
        this.counts = res.data.productionReport.counts;
        this.stopLoading();
      });
    },

    resetSearchOnEmpty() {
      if (this.search != "") return;
      this.getProductByCat();
    },

    searchItems() {
      if (this.search == "") return;
    },
  },
  mixins: [loadingMixin],
};
</script>
<style lang="scss" scoped>
::v-deep .wdt {
  width: 175px;
}
</style>
